module.exports = __webpack_public_path__ + "static/media/doctor_offline.d6218ea9.png";